<template>
  <span class="title_btn excel_btn_wrap">
    <el-button class="title_btn" type="success" :size="size" :loading="downloadLoading" @click="excelDown()">엑셀 출력</el-button>
  </span>
</template>

<script>

  export default {
    name: 'ExcelDown',
    props: {
      list: {
        type: Array,
        default: [],
      },
      header: {
        type: Array,
        default: []
      },
      filterVal: {
        type: Array,
        default: []
      },
      fileName: {
        type: null,
        default: 'table-list'
      },
      size: {
        type: String,
        default : ''
      }
    },
    components: {
    },
    computed: {

    },
    data() {
      return{
        title: this.$route.meta.title,
        downloadLoading: false,
      }
    },
    methods: {
      excelDown() {
        this.downloadLoading = true;
        import('@/vendor/Export2Excel').then(excel => {
          //const tHeader = ['아이디', '이름', '휴대폰번호', '가입유형', '소속팀', '가입일', ' 마지막로그인'];
          //const filterVal = ['mb_email', 'mb_name', 'mb_hp', 'joinTypeName', 'team.p_name', 'created_at', 'mb_last_login'];
          const tHeader = this.header;
          const filterVal = this.filterVal;
          const data = this.formatJson(filterVal, this.list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.fileName
          })
          this.downloadLoading = false;
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            //return v[j]
            return this.$_.result(v, j)
          }
        }))
      }
    }
  }
</script>
